import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@/components/theme-provider'
import { Toaster } from '@/components/ui/sonner'
import LoginPage from '@/pages/LoginPage'
import DashboardLayout from '@/layouts/DashboardLayout'
import DashboardPage from '@/pages/DashboardPage'
import DailyReportsPage from '@/pages/DailyReportsPage'
import VerificationPage from '@/pages/VerificationPage'
import BroadcastPage from '@/pages/BroadcastPage'
import DictionaryPage from '@/pages/DictionaryPage'
import SettingsPage from '@/pages/SettingsPage'

function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="daily-reports" element={<DailyReportsPage />} />
            <Route path="verification" element={<VerificationPage />} />
            <Route path="broadcast" element={<BroadcastPage />} />
            <Route path="dictionary" element={<DictionaryPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App

